var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_1335",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.64 0.861084H0.900024V26.2781H28.64V0.861084Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_1335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.007 2.00098H4.53104C3.90636 2.01722 3.3072 2.25221 2.83804 2.66498C2.57814 2.89182 2.37163 3.17335 2.23333 3.48939C2.09502 3.80542 2.02833 4.14814 2.03804 4.49298V16.865C2.0383 17.5255 2.30083 18.159 2.76793 18.6261C3.23502 19.0932 3.86846 19.3557 4.52904 19.356H11.31L10.772 25.136L18.847 19.356H25.008C25.6688 19.356 26.3025 19.0936 26.7698 18.6264C27.2371 18.1593 27.4998 17.5257 27.5 16.865V4.49298C27.5 4.16564 27.4355 3.84151 27.3102 3.5391C27.185 3.23669 27.0013 2.96193 26.7698 2.73051C26.5383 2.4991 26.2634 2.31556 25.961 2.19038C25.6585 2.06521 25.3344 2.00085 25.007 2.00098Z",
    stroke: "white",
    strokeWidth: 1.97,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussion);
export default __webpack_public_path__ + "static/media/discussion.f853417fa0bd8e9df06180a2266bc882.svg";
export { ForwardRef as ReactComponent };